import { DiagnosisExist } from './DiagnosisExist';
import { DiagnosisDescOrFile } from './DiagnosisDescOrFile';
import { FamilyDiagnosis } from './FamilyDiagnosis';

export const DiseaseMentalQuestionnaire = () => {
  return (
    <>
      <DiagnosisExist />
      <DiagnosisDescOrFile />
      <FamilyDiagnosis />
    </>
  );
};
